import { get } from "lodash";
import { ComponentProps } from "react";
import { FieldPath, FieldValues, useFormContext } from "react-hook-form";

import { Button } from "@/components/elements/Button";
import cn from "@/helpers/classNames";
import { ArrowPathIcon } from "@heroicons/react/16/solid";

export const DataFetch_FieldError = "data-fetch-failed";

export function FieldErrorMessage<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: { name: TName } & Omit<ComponentProps<"div">, "name"> & {
      onRetry?: () => void;
    },
) {
  const { clearErrors, formState } = useFormContext();
  const { errors } = formState;
  const error = get(errors, props.name);
  if (!error || typeof error.message !== "string") {
    return null;
  }

  return (
    <div className={cn("mt-1 text-sm text-red-500", props.className)}>
      {error.message}
      {error.type === DataFetch_FieldError && props.onRetry && (
        <Button
          onClick={() => {
            if (props.onRetry) {
              clearErrors(props.name);
              props.onRetry();
            }
          }}
          size="xs"
          icon={<ArrowPathIcon />}
          className="ml-1"
        >
          Retry
        </Button>
      )}
    </div>
  );
}
